export default __webpack_public_path__ + "static/media/Mangerica-Light.1af90427.otf";